<style scoped>
  .m-t-9 { margin-top: 9px }
</style>

<template>
  <section class="container" >
    <div class="columns">
      <div class="is-5 m-t-9">

        <portal-box style="min-height: 309px">
          <h1 slot="titulo" class="title">Meta <b-tag type="is-primary" size="is-medium">{{ usuario.codigo }}</b-tag></h1>

        <b-table :data="lista" :loading="loading" class="row-button" :narrowed="true">
          <portal-lista-vazia slot="empty"/>

          <template slot-scope="props">

            <b-table-column label="META">
              {{ props.row.META | moeda }}
            </b-table-column>

            <b-table-column label="Mês">
              {{ props.row.REALIZADO | moeda }}
            </b-table-column>

            <b-table-column numeric label="% Realizado">
              {{ props.row.PERC_REALIZADO }}%
            </b-table-column>

            <b-table-column label="À Realizar">
              {{ props.row.REALIZAR | moeda}}
            </b-table-column>

            <b-table-column numeric label="% À Realizar">
              {{ props.row.PERC_REALIZAR }}%
            </b-table-column>

          </template>

        </b-table>

        </portal-box>

      </div>

      <div class="column is-7">
        <grafico/>
      </div>
    </div>
  </section>
</template>

<script>
  import {auth} from '../../mixins/auth'
  import Quadro from '../../components/Quadro'
  import QuadroMoeda from '../../components/QuadroMoeda'
  import Grafico from '../../components/Grafico'
  import RankingProduto from '../../components/RankingProduto'

  export default {
    components: {Quadro, QuadroMoeda, Grafico, RankingProduto},
    mixins: [auth],
    created () {
      this.buscarMetas()
    },
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/meta').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    data () {
      return {
        loading: false,
        meta: {},
        lista: []
      }
    },
    methods: {
      buscarMetas () {
        this.loading = true
        this.$http.get(this.$URL.METAS.MES_CORRENTE, this.$header()).then(res => {
          this.meta = res.body
          this.lista.push(this.meta)
          this.loading = false
        }, res => { this.loading = false })
      }
    },
    computed: {
      parametros () {
        return this.$store.state.parametros
      },
      usuario () {
        return this.$air.usuarioLogado()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/meta/Dashboard.vue